import React, { useContext, useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { hasToken } from "../../utils/auth";
import { getLocalValue } from "../../utils/auth";
import AuthApi from "../../context/AuthApi";
import { Role } from "../../config/Roles";

export const PrivateRoute = ({ children, ...rest }) => {
  const location = useLocation();
  const Auth = useContext(AuthApi);
  const isAuthenticated = hasToken();

  useEffect(() => {
    const userRole = parseInt(getLocalValue("u_role"));
    const coachingRole = parseInt(getLocalValue("u_coaching_role"));
    Auth.setAuth(isAuthenticated);
    Auth.setIsCoach(
      userRole === Role.COACH || coachingRole === Role.COORDINATOR
    );
    Auth.setIsCampaignCoord(
      coachingRole === Role.CAMPAIGN_MANAGER || coachingRole == Role.COORDINATOR
    );
    Auth.setIsCampaignAdmin(coachingRole === Role.CAMPAIGN_MANAGER);
    Auth.setUid(parseInt(getLocalValue("uid")));
  }, [Auth]);

  useEffect(() => {
    // If the user is not authenticated, store the target path
    // so that we can redirect them there after login/change password.
    if (!isAuthenticated) {
      localStorage.setItem("target_path", location.pathname + location.search);
    }
  }, [isAuthenticated, location]);

  return (
    <Route
      {...rest}
      render={() => (isAuthenticated ? children : <Redirect to="/" />)}
    ></Route>
  );
};
